import { useRef, useState } from 'react';
import type { ZipTie } from '@erp/workflows';
import type { EdgeGeometry } from 'src/lib/workflows/zipTieGeometry';
import { useHoveredWireKeys, type ZipTieRenderState } from './zipTieRouting';

const NO_IDS: ReadonlySet<string> = new Set();
const NO_TIES: readonly ZipTie[] = [];

export function useViewZipTieState(zipTies: readonly ZipTie[] | undefined): {
  renderState: ZipTieRenderState | null;
  hoveredTieId: string | null;
  setHoveredTieId: (id: string | null) => void;
  endpointsRef: { readonly current: Map<string, EdgeGeometry> };
} {
  const endpointsRef = useRef(new Map<string, EdgeGeometry>());
  const [hoveredTieId, setHoveredTieId] = useState<string | null>(null);
  const ties = zipTies ?? NO_TIES;
  const hoveredWireKeys = useHoveredWireKeys(ties, hoveredTieId);
  const renderState: ZipTieRenderState | null =
    ties.length === 0
      ? null
      : {
          ties,
          hoveredWireKeys,
          previewWireKeys: NO_IDS,
          endpoints: endpointsRef,
        };
  return { renderState, hoveredTieId, setHoveredTieId, endpointsRef };
}
